//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
SPLM.Diagramming.HorizontalCenteringMarkType = Object.freeze({
    "None" : "None", "LeftArrow" : "LeftArrow", "RightArrow" : "RightArrow", "LeftandRightArrow" : "LeftandRightArrow", "LeftandRightLine" : "LeftandRightLine"});

SPLM.Diagramming.VerticalCenteringMarkType = Object.freeze({
    "None" : "None", "BottomArrow" : "BottomArrow", "TopArrow" : "TopArrow", "BottomandTopArrow" : "BottomandTopArrow", "BottomandTopLine" : "BottomandTopLine"});

SPLM.Diagramming.Method = Object.freeze({
    "None" : "None", "Standard" : "Standard", "Custom" : "Custom"});

SPLM.Diagramming.ZoneOrigin = Object.freeze({
    "BottomRight" : "BottomRight", "TopLeft" : "TopLeft", "TopRight" : "TopRight", "BottomLeft" : "BottomLeft"});

SPLM.Diagramming.FontEnum = Object.freeze({
    "Blockfont" : "Blockfont"});

SPLM.Diagramming.ArrowStyleType = Object.freeze({
    "Filled" : "Filled", "Closed" : "Closed", "ClosedSolid" : "ClosedSolid", "Open" : "Open"});

SPLM.Diagramming.ArrowDirectionType = Object.freeze({
    "OutofSheet" : "OutofSheet", "IntoSheet" : "IntoSheet"});

SPLM.Diagramming.TrimmingMarkStyleType = Object.freeze({
    "Triangle" : "Triangle", "Corner" : "Corner"});

export default SPLM;